<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
import agentUtil from "./utils/agentUtil";

export default {
	name : "App",
	data () {
		return {};
	},
	beforeCreate () {
		this.$store.dispatch("setConfig");
	},
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue